import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import PMSMobileLogo from "../resources/PMSMobileLogo.png";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

function MainLayout({ navItems, rootUrl }) {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const [mobileOpen, setMobileOpen] = useState(false);
  //   const [page, setPage] = useState("home");
  //   const scrollToSection = (id) => {
  //     const section = document.getElementById(id.toLowerCase());
  //     section?.scrollIntoView({ behavior: "smooth" });
  //     setMobileOpen(false);
  //   };

  const changePage = (p) => {
    // setPage(p);
    // setMobileOpen(false);

    navigate(p);
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "auto",
    });
  }, [pathname]);

  return (
    <div className="min-h-screen bg-slate-50 text-slate-900">
      <header className="sticky top-0 z-50 border-b border-slate-200 bg-white/90 backdrop-blur">
        <div className="relative mx-auto flex max-w-7xl items-center justify-between px-4 py-4 sm:px-6 lg:px-8">
          {/* Left: Logo */}
          <button
            onClick={() => changePage(rootUrl)}
            className="flex items-center cursor-default"
          >
            <img
              src={PMSMobileLogo}
              alt="Logo"
              style={{ width: 260, height: 60 }}
            />
          </button>

          {/* Center: Nav */}
          <nav className="absolute left-1/2 hidden -translate-x-1/2 md:flex items-center gap-7">
            {navItems.map((item, index) => (
              <button
                key={index}
                onClick={() => changePage(item.path)}
                className="text-sm font-medium text-slate-600 transition hover:text-slate-950"
              >
                {item.name}
              </button>
            ))}
          </nav>

          {/* Right: Mobile Menu */}
          <button
            className="md:hidden"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            {mobileOpen ? <X /> : <Menu />}
          </button>
        </div>

        {mobileOpen && (
          <div className="border-t border-slate-200 bg-white px-4 py-4 md:hidden">
            <div className="flex flex-col gap-3">
              {navItems.map((item, index) => (
                <button
                  key={index}
                  onClick={() => changePage(item.path)}
                  className="rounded-xl px-3 py-2 text-left text-sm font-medium text-slate-700 hover:bg-slate-100"
                >
                  {item.name}
                </button>
              ))}
            </div>
          </div>
        )}
      </header>
      <main>
        <Outlet />
      </main>

      <footer className="border-t border-slate-200 bg-white">
        <div className="mx-auto flex max-w-7xl flex-col gap-4 px-4 py-8 text-sm text-slate-500 sm:px-6 md:flex-row md:items-center md:justify-between lg:px-8">
          <p>©2026 Phyxsius Solutions Inc. All rights reserved.</p>
          <p>
            Software Development • Software Rental • Property Management Systems
          </p>
        </div>
      </footer>
    </div>
  );
}

export default MainLayout;
